// extracted by mini-css-extract-plugin
module.exports = {"cmaxC":"#f0be5b","cminC":"#e15d4d","normalC":"#70b603","lfs":"12","ds":"1754","dh":"1100","stripeBgC":"#f3f3f3","stripeInnerBorderC":"#979797"};